/* eslint-disable react/jsx-no-target-blank */
import {useContext, useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import ConfigContext from '../../../../app/contexts/Config/ConfigContext'

const Footer = () => {
  const cfg = useContext(ConfigContext);
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          2023&copy;
        </span>
        <a
          href={cfg.footer.url}
          target='_blank'
          className='text-gray-800 text-hover-primary'
        >
          {cfg.footer.criado_por}
        </a>
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
